// src/components/GiftCard.jsx
import React from "react";
import { Card, Box, Typography, Button } from "@mui/material";
import GiftIcon from "../static/img/gift.png";

const GiftCard = ({ onWatchNow }) => {
  return (
    <Card
      sx={{
          backgroundColor: "rgba(0, 0, 0, 0.04)",
        borderRadius: "16px",
        p: 2,
        mt: 1,
        color: "#fff",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Title + Icon */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: -1,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "#FFC107" }}>
          Win a Gift!
        </Typography>

        {/* Floating + Bobbing Icon */}
        <Box
          sx={{
            width: 72,
            height: 72,
            ml: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "& img": {
              width: "100%",
              height: "100%",
              animation: "floating 3s ease-in-out infinite",
              "@keyframes floating": {
                "0%": {
                  transform: "translateY(0px) scale(1)",
                  filter: "drop-shadow(0px 4px 6px rgba(0,0,0,0.4))",
                },
                "50%": {
                  transform: "translateY(-6px) scale(1.18)", // moves slightly upward while growing
                  filter: "drop-shadow(0px 12px 16px rgba(0,0,0,0.55))",
                },
                "100%": {
                  transform: "translateY(0px) scale(1)",
                  filter: "drop-shadow(0px 4px 6px rgba(0,0,0,0.4))",
                },
              },
            },
          }}
        >
          <img src={GiftIcon} alt="Gift" />
        </Box>
      </Box>

      {/* Description */}
      <Typography variant="body2" sx={{ color: "F5F5F5", mb: 2 }}>
        Watch videos & click on easter eggs in them. Unlock the puzzles to win
        an exciting gift!
      </Typography>

      {/* Button */}
      <Button
        variant="contained"
        onClick={onWatchNow}
        sx={{
          backgroundColor: "#FFA800",
          color: "#000",
          fontWeight: "bold",
          borderRadius: "8px",
          textTransform: "none",
          "&:hover": { backgroundColor: "#FFA000" },
        }}
        fullWidth
      >
        Watch Now
      </Button>
    </Card>
  );
};

export default GiftCard;
